import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const handleExportPDF = async (pdfRef, filename) => {
  const table = pdfRef.current;
  if (!table) return;

  // Save original styles
  const originalOverflow = table.style.overflow;
  const originalWidth = table.style.width;

  // Expand table to full scrollable width
  table.style.overflow = "visible";
  table.style.width = `${table.scrollWidth}px`;

  await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for reflow

  // Take screenshot of full content
  const canvas = await html2canvas(table, {
    scrollX: -window.scrollX,
    scrollY: -window.scrollY,
    useCORS: true,
  });

  // Restore original styles
  table.style.overflow = originalOverflow;
  table.style.width = originalWidth;

  const imgData = canvas.toDataURL("image/jpeg", 0.7);

  // PDF config
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "px",
    format: "a4",
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = canvas.width;
  const imgHeight = canvas.height;

  // Scale the image width to fit the PDF page width
  const scale = pageWidth / imgWidth;
  const scaledHeight = imgHeight * scale;

  let position = 0;

  // Add image in chunks (if taller than 1 page)
  while (position < scaledHeight) {
    const remainingHeight = scaledHeight - position;
    const heightOnThisPage = Math.min(pageHeight, remainingHeight);

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      -position, // Crop vertically by shifting image upwards
      pageWidth,
      scaledHeight
    );

    position += pageHeight;

    if (position < scaledHeight) {
      pdf.addPage(); // Add new page if content still remains
    }
  }

  pdf.save(`${filename}.pdf`);
};
